{
  "DE": {
    "appTitle": "TNG Weihnachtskarten-Porträt",
    "appTitleTest": "--- TEST --- TNG Weihnachtskarten-Porträt",
    "unknownErrorTryAgainLater": "Es ist ein Fehler aufgetreten. Bitte versuche es später noch einmal.",
    "cutoutAlt": "Dein Foto, freigestellt",
    "noCutoutYet": "Noch kein Foto",
    "uploading": "Dein Foto wird hochgeladen …",
    "jobQueued": "Dein Bild wartet, bis es an der Reihe ist …",
    "cutoutProcessing": "Dein Foto wird freigestellt …",
    "cutoutFailed": "Das Freistellen hat nicht geklappt. Bitte versuche es noch einmal oder lade ein anderes Foto hoch.",
    "unsupportedPhoto": "Bitte wähle ein Foto im Format JPEG, PNG oder WebP.",
    "photoTooLarge": "Bitte wähle ein Foto mit höchstens 7 MB.",
    "uploadFailed": "Das Hochladen hat nicht geklappt. Bitte versuche es noch einmal.",
    "christmasImageAlt": "Dein Weihnachtsbild",
    "noChristmasImageYet": "Noch kein Weihnachtsbild",
    "christmasImageProcessing": "Dein Weihnachtsbild wird erstellt …",
    "christmasImageProcessingBroad": "Dein Weihnachtsbild wird erstellt, das dauert etwa 30 Sekunden …",
    "christmasImageFailed": "Das Weihnachtsbild hat nicht geklappt. Bitte versuche es noch einmal.",
    "reviewPortraits": "Alle Porträts prüfen",
    "yourPortraitFlagged": "Ein Admin hält dein Porträt für die Karten nicht für geeignet. Bitte lade ein neues Foto hoch oder wähle ein anderes Weihnachtsbild.",
    "adminsOnly": "Diese Seite ist nur für Admins.",
    "galleryTitle": "Porträts prüfen",
    "galleryHint": "Markiere Porträts, die für die Karten nicht taugen. Wer markiert ist, sieht das auf der eigenen Seite, bis das Porträt geändert ist.",
    "findColleague": "Person suchen",
    "filterLabel": "Anzeigen",
    "filterChosen": "Ausgewählt",
    "filterFlagged": "Markiert",
    "notChosenYet": "Noch nicht ausgewählt",
    "nothingToShow": "Hier gibt es nichts zu sehen.",
    "showMore": "Mehr anzeigen",
    "flag": "Als ungeeignet markieren",
    "unflag": "Markierung entfernen",
    "photoOnlyShort": "Nur Foto",
    "noPortrait": "Kein Porträt",
    "photoOf": "Foto von",
    "christmasImageOf": "Weihnachtsbild von",
    "flaggedAsUnsuitable": "Für die Karten ungeeignet",
    "savedForYourCards": "Gespeichert. So zeigen die Weihnachtskarten dein Unterschrifts-Porträt.",
    "pageTitle": "Mein Weihnachtskarten-Porträt",
    "subtitleCard": "Prüfe dein Unterschrifts-Porträt, dann schick es ab oder ändere es nach deinen Wünschen.",
    "subtitlePhoto": "Wähle das Foto, aus dem dein Weihnachtsbild entsteht.",
    "subtitleChristmasImage": "Wähle das Weihnachtsbild für dein Porträt.",
    "cardTitle": "Vorschau deines Porträts",
    "cardHintUnsaved": "Fahr mit der Maus über das Bild oder nutze die Schalter darunter, um das Porträt zu prüfen. Dann schick es ab.",
    "cardHintSaved": "Fahr mit der Maus über das Bild oder nutze die Schalter darunter, um beide Versionen deines Porträts zu sehen.",
    "cardHintPhotoOnly": "So sieht dein Unterschrifts-Porträt aus. Du hast dich gegen ein Weihnachtsbild entschieden.",
    "christmasImageKept": "Weihnachtsbild hinzugefügt. Schick dein Porträt ab, sobald es dir gefällt.",
    "photoOnlyKept": "Die Karten zeigen nur dein Foto. Schick dein Porträt ab, sobald es dir gefällt.",
    "submitted": "Für deine Weihnachtskarten gespeichert. Du kannst diese Seite jetzt schließen.",
    "saving": "Wird gespeichert …",
    "submitCard": "Passt so – Porträt abschicken",
    "changePhoto": "Foto ändern",
    "changeChristmasImage": "Weihnachtsbild ändern",
    "addChristmasImage": "Weihnachtsbild hinzufügen",
    "noChristmasImageThanks": "Kein Weihnachtsbild, danke",
    "backToCard": "Zurück zur Porträt-Vorschau",
    "cardFace": "Version des Porträts",
    "cardFront": "Normal",
    "cardFrontCaption": "Foto",
    "onHover": "Mit der Maus darüber",
    "onHoverCaption": "Weihnachtsbild",
    "photoTitle": "Neues Foto",
    "photoHintEmpty": "Lade ein Foto hoch, um loszulegen. Daraus entsteht dein Weihnachtsbild.",
    "photoHint": "Aus diesem Foto entsteht dein Weihnachtsbild. Ein neues Foto oder neues Freistellen bringt ein neues Weihnachtsbild.",
    "uploadPhoto": "Foto hochladen",
    "uploadNewPhoto": "Neues Foto hochladen",
    "cutOutAgain": "Dieses Foto neu freistellen",
    "dropPhotoHere": "Foto hier ablegen",
    "christmasImageTitle": "Neues Weihnachtsbild",
    "christmasImageHint": "So erscheinst du, wenn jemand mit der Maus über dein Porträt fährt. Mit dem Schalter unter dem Bild vergleichst du es am besten mit der normalen Version, bevor du dich entscheidest.",
    "keepChristmasImage": "Dieses Bild behalten",
    "generateChristmasImage": "Weihnachtsbild erstellen",
    "generateAnother": "Noch eins erstellen",
    "aboutThirtySeconds": " · etwa 30 Sek.",
    "advancedOptions": "Erweiterte Optionen",
    "hideAdvancedOptions": "Erweiterte Optionen ausblenden",
    "methodLabel": "Bearbeitung",
    "methodFocused": "Gezielt",
    "methodFocusedCaption": "Ändert nur Mütze und Outfit",
    "methodBroad": "Umfassend",
    "methodBroadCaption": "Ändert mehr · etwa 30 Sek.",
    "broadEditStabilityHint": "Umfassende Bearbeitungen können weniger stabil sein und brauchen eventuell mehrere Versuche.",
    "withOutfit": "Mit Weihnachtsoutfit",
    "advancedOptionsHint": "Diese Einstellungen gelten ab dem nächsten Bild, das du erstellst.",
    "navOwnPortrait": "Mein Weihnachtskarten-Porträt",
    "navAddressCollection": "Adresssammlung",
    "navAdmin": "Admin",
    "opensInNewTab": "öffnet sich in einem neuen Tab",
    "closePanel": "Schließen",
    "previousPortrait": "Vorheriges Porträt",
    "nextPortrait": "Nächstes Porträt"
  },
  "EN": {
    "appTitle": "TNG Christmas Card Portrait",
    "appTitleTest": "--- TEST --- TNG Christmas Card Portrait",
    "unknownErrorTryAgainLater": "An error occurred. Please try again later.",
    "cutoutAlt": "Your photo, cut out",
    "noCutoutYet": "No photo yet",
    "uploading": "Uploading your photo …",
    "jobQueued": "Your image is waiting for its turn …",
    "cutoutProcessing": "Cutting out your photo …",
    "cutoutFailed": "Cutting out your photo did not work. Please try again or upload a different photo.",
    "unsupportedPhoto": "Please pick a JPEG, PNG or WebP photo.",
    "photoTooLarge": "Please pick a photo of at most 7 MB.",
    "uploadFailed": "The upload did not work. Please try again.",
    "christmasImageAlt": "Your Christmas image",
    "noChristmasImageYet": "No Christmas image yet",
    "christmasImageProcessing": "Creating your Christmas image …",
    "christmasImageProcessingBroad": "Creating your Christmas image, this takes about 30 seconds …",
    "christmasImageFailed": "Creating your Christmas image did not work. Please try again.",
    "reviewPortraits": "Review All Portraits",
    "yourPortraitFlagged": "An admin found your portrait unsuitable for the cards. Please upload a new photo or choose a different Christmas image.",
    "adminsOnly": "This page is for admins only.",
    "galleryTitle": "Review portraits",
    "galleryHint": "Flag the portraits that won't do for the cards. Whoever is flagged sees it on their own page until their portrait changes.",
    "findColleague": "Find a colleague",
    "filterLabel": "Show",
    "filterChosen": "Chosen",
    "filterFlagged": "Flagged",
    "notChosenYet": "Not chosen yet",
    "nothingToShow": "Nothing to show here.",
    "showMore": "Show more",
    "flag": "Flag as unsuitable",
    "unflag": "Remove flag",
    "photoOnlyShort": "Photo only",
    "noPortrait": "No portrait",
    "photoOf": "Photo of",
    "christmasImageOf": "Christmas image of",
    "flaggedAsUnsuitable": "Unsuitable for the cards",
    "savedForYourCards": "Saved. This is how the cards show your signature portrait.",
    "pageTitle": "My Christmas Card Portrait",
    "subtitleCard": "Check your signature portrait, then submit it or change it to your liking.",
    "subtitlePhoto": "Pick the photo your Christmas image is generated from.",
    "subtitleChristmasImage": "Pick the Christmas image for your portrait.",
    "cardTitle": "Portrait Preview",
    "cardHintUnsaved": "Hover over the picture or use the switch below to check your portrait, then submit it.",
    "cardHintSaved": "Hover over the picture or use the switch below to see both versions of your portrait.",
    "cardHintPhotoOnly": "This is how your signature portrait will look. You decided against a Christmas image.",
    "christmasImageKept": "Christmas image added. Submit your portrait when it looks right.",
    "photoOnlyKept": "The cards will show only your photo. Submit your portrait when it looks right.",
    "submitted": "Saved for your Christmas cards. You can close this page.",
    "saving": "Saving …",
    "submitCard": "Looks good — submit portrait",
    "changePhoto": "Change photo",
    "changeChristmasImage": "Change Christmas image",
    "addChristmasImage": "Add a Christmas image",
    "noChristmasImageThanks": "No Christmas image, thanks",
    "backToCard": "Back to the portrait preview",
    "cardFace": "Portrait version",
    "cardFront": "Normal",
    "cardFrontCaption": "Photo",
    "onHover": "On hover",
    "onHoverCaption": "Christmas image",
    "photoTitle": "New Photo",
    "photoHintEmpty": "Upload a photo to get started. Your Christmas image is generated from it.",
    "photoHint": "Your Christmas image is generated from this photo. A new photo or a new cut-out brings a new Christmas image.",
    "uploadPhoto": "Upload a photo",
    "uploadNewPhoto": "Upload a new photo",
    "cutOutAgain": "Cut out this photo again",
    "dropPhotoHere": "Drop your photo here",
    "christmasImageTitle": "New Christmas Image",
    "christmasImageHint": "This is how you appear when someone hovers over your portrait. Use the switch below the picture to compare it with the normal version before you decide.",
    "keepChristmasImage": "Keep this image",
    "generateChristmasImage": "Generate a Christmas image",
    "generateAnother": "Generate another",
    "aboutThirtySeconds": " · about 30 sec",
    "advancedOptions": "Advanced options",
    "hideAdvancedOptions": "Hide advanced options",
    "methodLabel": "Generation method",
    "methodFocused": "Focused edit",
    "methodFocusedCaption": "Changes only the hat and outfit",
    "methodBroad": "Broad edit",
    "methodBroadCaption": "Changes more · about 30 sec",
    "broadEditStabilityHint": "Broad edits can be less stable and may need multiple retries.",
    "withOutfit": "Use a Christmas outfit",
    "advancedOptionsHint": "These choices apply the next time you generate an image.",
    "navOwnPortrait": "My Christmas Card Portrait",
    "navAddressCollection": "Address Collection",
    "navAdmin": "Admin",
    "opensInNewTab": "opens in a new tab",
    "closePanel": "Close",
    "previousPortrait": "Previous portrait",
    "nextPortrait": "Next portrait"
  }
}
